var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBouncing3Dots = function SvgBouncing3Dots(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce0",
    attributeName: "cy",
    begin: "0;svgSpinners3DotsBounce1.end+0.25s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 3,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinners3DotsBounce1",
    attributeName: "cy",
    begin: "svgSpinners3DotsBounce0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".33,.66,.66,1;.33,0,.66,.33",
    values: "12;6;12"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBouncing3Dots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bouncing-3-dots.0ea7b9ead2e8e178ad036209c71ff887.svg";